import { postApi } from './apiBase';
import { global_search_quick, global_search_quick_paged } from './apiURL';

const quickSearch = (query, maxResults, { signal } = {}) =>
    postApi(
        global_search_quick,
        { query, maxResults },
        { signal, _suppressErrorPopup: true }
    );

const pagedQuickSearch = (query, page, pageSize, { signal } = {}) =>
    postApi(
        global_search_quick_paged,
        { query, page, pageSize },
        { signal, _suppressErrorPopup: true }
    );

export { quickSearch, pagedQuickSearch };
